import axios from 'axios'
import { logSearchError } from '../../listings-client/util/clientLogger'
import { authorizedCustomerProfileQuery } from './queries/authorizedCustomerProfileQuery'

export const getCustomerVipTier = (email, token, appVersion) => {
  if (email && token) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/pws/v0/pcln-graph/',
        method: 'post',
        data: {
          query: authorizedCustomerProfileQuery,
          variables: { email, token },
        },
        headers: {
          'apollographql-client-name': 'm-fly-search',
          'apollographql-client-version': `${appVersion}`,
          'x-pcln-search-source':
            'appname:mflysearch-pagename:listing-searchtype:ugs',
        },
      })
        .then(response =>
          resolve(
            response?.data?.data?.authorizedCustomerProfile?.loyalty?.tierLabel
          )
        )
        .catch(error => {
          logSearchError('profileql', error)
          reject(error)
        })
    })
  } else {
    return Promise.resolve('member')
  }
}
